// ABOUTME: Normaliza la matriz 4x4 que devuelve MediaPipe (facialTransformationMatrixes)
// ABOUTME: a column-major, que es lo que espera THREE.Matrix4.fromArray.

/**
 * MediaPipe documenta el layout de forma ambigua según versión. Detectamos por
 * dónde vive la traslación: column-major la guarda en [12..14]; row-major en [3,7,11].
 */
export function toColumnMajor(data: ArrayLike<number>): number[] {
  if (data.length !== 16) throw new Error(`Matriz 4x4 esperada, llegaron ${data.length} valores`);
  const m = Array.from(data);
  const colMajorTranslation = Math.abs(m[12]) + Math.abs(m[13]) + Math.abs(m[14]);
  const rowMajorTranslation = Math.abs(m[3]) + Math.abs(m[7]) + Math.abs(m[11]);
  if (rowMajorTranslation <= colMajorTranslation) return m;
  const t = new Array<number>(16);
  for (let r = 0; r < 4; r++) for (let c = 0; c < 4; c++) t[c * 4 + r] = m[r * 4 + c];
  return t;
}
